import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { Utils } from 'src/app/api/helper/utils';
import { ProtokollEintragEx } from 'src/app/api/model/model';
import { AuftragsKomponente, ProtokollEintrag } from 'src/app/api/model/swagger-model';
import { Auftragdetails } from '../auftragdetails.helper';
import { KomponenteBase } from './komponente';

const log = new Logger('AuftragStatusmeldungenComponent');

@Component({
    selector: 'auftrag-statusmeldungen-komponente',
    template: `
        <div *ngIf="auftrag.statusmeldungen.length">
          <div class="section">
            <h1>{{ getEinstellung('Titel', 'Statusmeldungen') }}</h1>

            <ion-list class="no-lines">
              <ion-item *ngFor="let p of auftrag.statusmeldungen" class="ion-no-padding">
                <div class="status-item-outer">
                    <div *ngIf="p.extraText2" class="extraText2">{{ p.extraText2 }}</div>
                    <div class="status-text">{{ p.name }} {{ p.extraText }}</div>
                </div>
              </ion-item>
            </ion-list>
          </div>
        </div>

        <div class="section" *ngIf="protokollListe.length">
          <h1>{{ 'Protokoll' }}</h1>

          <ion-list class="no-lines">
            <ion-item *ngFor="let p of protokollListe" class="ion-no-padding">
              {{ p.Text }} {{ p.Info1 }} {{ p.Info2 }}
            </ion-item>
          </ion-list>
        </div>
    `,
    styles: [`
    `],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AuftragStatusmeldungenComponent extends KomponenteBase implements OnInit {

    @Input() auftragdetails: Auftragdetails;
    @Input() komponente: AuftragsKomponente;

    protokollListe: ProtokollEintragEx[] = [];

    personAnzeigen = false;
    uhrzeitAnzeigen = false;

    constructor(
        private router: Router,
        protected cdr: ChangeDetectorRef) {
        super(cdr);
    }

    ngOnInit() {
        super.ngOnInit();

        this.subscriptions.push(this.auftragdetails.detectChanges.subscribe(() => {
            this.refreshView();
        }));

        this.refreshView();
    }

    refreshView() {
        log?.debug('refreshView');

        this.protokollListe = this.auftrag?.Protokoll ?? [];

        if (this.auftrag?.statusmeldungen) {
            this.personAnzeigen = this.getEinstellung('PersonAnzeigen', 'nein') === 'ja';
            this.uhrzeitAnzeigen = this.getEinstellung('UhrzeitAnzeigen', 'nein') === 'ja';

            for (const item of this.auftrag.statusmeldungen) {
                item.extraText2 = '';

                if (this.uhrzeitAnzeigen && item.datum) {
                    if (item.extraText2) {
                        item.extraText2 += ', ';
                    }

                    const m = Utils.parseDatum(item.datum);
                    item.extraText2 += m?.format('HH:mm') + ' Uhr';
                }

                if (this.personAnzeigen && item.personalName) {
                    if (item.extraText2) {
                        item.extraText2 += ' - ';
                    }

                    item.extraText2 += item.personalName;
                }
            }
        }
    }
}
